module.exports = __webpack_public_path__ + "static/faq5-f6e32192e07b4afc0d1afd44e35ef06b.jpg";